import { render, staticRenderFns } from "./BaskoNextGenDetail.vue?vue&type=template&id=c82f7fbe&"
import script from "./BaskoNextGenDetail.vue?vue&type=script&lang=js&"
export * from "./BaskoNextGenDetail.vue?vue&type=script&lang=js&"
import style0 from "./BaskoNextGenDetail.vue?vue&type=style&index=0&id=c82f7fbe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports